import React, { useState, useEffect } from "react";
import { Page, Link, Icon } from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";

const OrderPage = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(API_BASE_URL + "orders", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          cust_id: localStorage.getItem("id"),
        },
      })
      .then((response) => setData(response.data.data))
      .catch((error) => console.log(error));
  }, []);

  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back reloadAll>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>
                </Link>
                <h2>Orders</h2>
              </div>
            </div>
          </header>
          <section className="section-b-space profile-form mt-3">
            <div className="custom-container p-0">
              <div className="row gy-3">
                {data.map((item, index) => (
                  <div className="bid-web-view-div">
                    <div className="col-12 ">
                      <a href={`/order_details/${item.id}/`}>
                        <div className="vertical-product-box order-box">
                          <div className="vertical-box-img">
                            <img
                              className="img-fluid img"
                              src={require("./../images/restaurant.png")}
                              alt="vp1"
                            />
                          </div>
                          <div className="vertical-box-details">
                            <div className="vertical-box-head">
                              <div className="restaurant">
                                <h5 className="dark-text text-capitalize">
                                  {item.event_name}
                                </h5>
                                <h5 className="theme-color">
                                  ${item.grand_total.toFixed(2)}
                                </h5>
                              </div>
                              {item.delivery_type !== "Pick up" ? (
                                <h6 className="food-items text-capitalize mb-2">
                                  <Icon
                                    ios="material:location_on"
                                    aurora="material:location_on"
                                    md="material:location_on"
                                    className="text-success text-3"
                                  />{" "}
                                  {item.add_lin_1}, {item.city}, {item.zip_code}
                                </h6>
                              ) : (
                                <h6 className="food-items text-capitalize mb-2"></h6>
                              )}
                            </div>
                            <div className="reorder">
                              <h6 className="rating-star">
                                <ul className="timing">
                                  <li>
                                    <Icon
                                      ios="material:groups"
                                      aurora="material:groups"
                                      md="material:groups"
                                      className="text-muted text-4"
                                    />{" "}
                                    {item.event_kids_size +
                                      item.event_adult_size}
                                  </li>
                                  <li>{item.event_date}</li>
                                </ul>
                                <a
                                  className="btn theme-btn order mt-0"
                                  role="button"
                                >
                                  {item.order_status_text}
                                </a>
                                <a
                                  className="btn theme-btn order mt-0"
                                  role="button"
                                >
                                  {item.delivery_type}
                                </a>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </div>
    </Page>
  );
};

export default OrderPage;
